// Matches the UTC+3 datetime contract used by the Reports section and the backend
// `reportTimezone.js` (REPORT_TIMEZONE = 'Etc/GMT-3').
//
// datetime-local inputs produce `YYYY-MM-DDTHH:mm` (no seconds, no offset). The
// backend reports/transaction filters interpret such wall-clock values as UTC+3
// only when an explicit offset is present, so we append `+03:00` before sending.
//
// Idempotent: if the value already carries an explicit offset or UTC marker it is
// returned unchanged, so calling this more than once (e.g. on submit + on search)
// never double-appends "+03:00".
export const toReportDateTimeString = (dateTimeLocal) => {
  if (!dateTimeLocal) return "";
  if (/[zZ]|[+-]\d{2}:?\d{2}$/.test(dateTimeLocal)) return dateTimeLocal;
  return `${dateTimeLocal}:00+03:00`;
};
